module.exports = __webpack_public_path__ + "static/media/Santorini.783aa5f3.jpg";